import React from 'react';

import '../style.css';

export default function HeartIcon({ stroke = 'var(--cool-grey)', fill = 'transparent' }) {
  return (
    <svg
      viewBox='0 0 42 42'
      style={{
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}>
      <g>
        <path
          d='M31.9,20.2L21.4,32.7L10.9,20.2C9.7,18.4,9.2,17.3,9.2,15.7c0,-3,2.1,-5.7,5.2,-5.8c2.6,0,5.4,2.6,7,4.6c1.5,-1.9,4.4,-4.6,7,-4.6c3,0,5.2,2.8,5.2,5.8c0,1.6,-.4,2.8,-1.7,4.5Z'
          style={{
            fill: fill,
            stroke: stroke,
            strokeWidth: 2,
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
          }}
        />
      </g>
    </svg>
  );
}
